<p-multiSelect
  optionLabel="name"
  filterBy="name"
  [styleClass]="'w-full'"
  [panelStyle]="{ width: '100%' }"
  [optionLabel]="'label'"
  [appendTo]="'body'"
  [display]="'chip'"
  [optionValue]="'id'"
  [formControl]="locationFormControl"
  [options]="(countryList$ | async) || []"
  placeholder="{{ 'Select one or more' | translate }}">
  <ng-template let-item pTemplate="item">
    <div class="country-item country-item-value-select">
      <img
        src="/assets/images/blocks/flag/flag_placeholder.png"
        [class]="'flag flag-' + item.iso_code?.toLowerCase()" />
      <div class="ml-1">{{ item.name | translate }}</div>
    </div>
  </ng-template>

  <ng-template pTemplate="dropdownicon">
    <i class="pi pi-map"></i>
  </ng-template>
  <ng-template pTemplate="filtericon">
    <i class="pi pi-map-marker"></i>
  </ng-template>

  <ng-template let-selectedCountries pTemplate="selectedItems">
    @if (selectedCountries) {
      <div class="flex flex-row flex-wrap gap-3">
        @for (option of selectedCountries; track option) {
          <div class="country-item country-item-value">
            <img
              src="/assets/images/blocks/flag/flag_placeholder.png"
              [class]="'flag flag-' + option.iso_code?.toLowerCase()" />
            <div class="ml-1">{{ option.name | translate }}</div>
          </div>
        }
      </div>
    }

    @if (!selectedCountries || selectedCountries.length === 0) {
      <div class="country-placeholder">
        {{ 'Select countries' | translate }}
      </div>
    }
  </ng-template>
</p-multiSelect>
